import { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { PermissionProvider } from "@/contexts/PermissionContext";
import { Sidebar } from "./Sidebar";
import { TopBar } from "./TopBar";

export function AppLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  return (
    <PermissionProvider>
      <div className="flex min-h-screen">
        <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />

        <div className="flex flex-1 flex-col lg:ml-64">
          <TopBar onMenuOpen={() => setSidebarOpen(true)} />

          <main className="flex-1 px-4 py-6 sm:px-6 lg:p-4">
            <div className="relative mx-auto max-w-12xl overflow-hidden rounded-xl border border-slate-200 bg-white p-5 shadow-sm sm:px-6 lg:pt-4 lg:pb-8">
              <div className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-brand-500 via-accent-400 to-brand-500" />
              <ErrorBoundary key={location.pathname}>
                <Outlet />
              </ErrorBoundary>
            </div>
          </main>

          <footer className="px-4 pb-4 text-right sm:px-6 lg:px-4">
            <p className="text-xs text-slate-400">
              &copy; {new Date().getFullYear()} Patascore. All rights reserved.
            </p>
          </footer>
        </div>
      </div>
    </PermissionProvider>
  );
}
